import { Menu, ScrollPanel } from 'primereact';
import { useContext, useEffect, useState, updateState } from 'react';
import { SpikerBoardContext } from '../context/SpikerBoardContext';
import axios from 'axios';
import AppConfig from '../AppConfig';

export default function CategoryList(props) {
    const [spikerBoardContext, setSpikerBoardContext] = useContext(SpikerBoardContext);
    const [menuItems, setMenuItems] = useState([]);
    useEffect(() => {
        //console.log("Catgeory list: ", spikerBoardContext.categories);//
        setMenuItems(spikerBoardContext.categories);
    }, [spikerBoardContext.categories]);
    return (
        <div className="h-full">
            <ScrollPanel className="custombar1 p-2" style={{ height: "100% " }} >
                <div className="grid grid-cols-1 p-4 absolute inset-x-0 top-0">
                    {
                        menuItems.map((el) => (
                            <CategoryRow key={el.ID} ID={el.ID} label={el.Name} onClickHandle={(id) => { props.onSetCategory(id) }} />
                        ))
                    }
                </div>
            </ScrollPanel>
        </div>

    )
}
export function CategoryRow(props) {
    return (

        <div className='h-8 border-b-1' onClick={() => {
            props.onClickHandle(props.ID)
        }}>
            {props.label}
        </div>

    )
}